import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from "react-bootstrap";
import Select from 'react-select';
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';
import { Settimane } from '../helper/settimaneTurniLavoro';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function FiltroSintesiSettimana(props) {
  const [settimanaLocale, setSettimanaLocale] = useState(null);
  const [settimanaCorrente, setSettimanaCorrente] = useState(null);
  const [sediOptions, setSediOptions] = useState([]);
  const { setMessage, settimana, filtroChanged, sedi, sede, sedeChanged } = props;
  
  useEffect(() => {
    if (settimana && (!settimanaLocale || settimana.value !== settimanaLocale.value)) {
      setSettimanaLocale(settimana);
    }
  }, [settimana, settimanaLocale]);

  useEffect(() => {
    if (sedi && sedi.length > 0) {
      const options = [
        { value: null, label: 'Tutte le sedi' },
        ...sedi.map(s => ({ value: s.id, label: s.descrizione }))
      ];
      setSediOptions(options);
      // Se non c'è una sede selezionata, imposta "Tutte le sedi"
      if (!sede && sedeChanged) {
        sedeChanged({ value: null, label: 'Tutte le sedi' });
      }
    }
  }, [sedi, sede, sedeChanged]);
  
  useEffect(() => {
    const handleSettimana = (data) => {
        const settimanaAttuale = Settimane.find(s => s.value === data.value);
        if (settimanaAttuale) {
          setSettimanaCorrente(settimanaAttuale);          
         
          if (!settimanaLocale) {
            setSettimanaLocale(settimanaAttuale);
          }
        }
      };
    const setMessageFromApi = (data) => {
      setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
    }
    getFromApi(buildUrl('settimanaCorrenteTurniLavoro'), handleSettimana, setMessageFromApi);
  }, [setMessage, settimanaLocale]);  

  const settimanaChanged = (newSettimana) => {
    setSettimanaLocale(newSettimana);    
    
    if (!settimana || newSettimana.value !== settimana.value) {
      filtroChanged(newSettimana);
    }
  };

  const handleSedeChange = (newSede) => {
    if (sedeChanged) {
      sedeChanged(newSede);
    }
  };

  const handlePrevSettimana = () => {
    if (!settimanaLocale) return;

    const currentIndex = Settimane.findIndex(s => s.value === settimanaLocale.value);
    if (currentIndex > 0) {
      const prevSettimana = Settimane[currentIndex - 1];
      settimanaChanged(prevSettimana);
    }
  };

  const handleNextSettimana = () => {
    if (!settimanaLocale) return;

    const currentIndex = Settimane.findIndex(s => s.value === settimanaLocale.value);
    if (currentIndex < Settimane.length - 1) {
      const nextSettimana = Settimane[currentIndex + 1];
      settimanaChanged(nextSettimana);
    }
  };

  const handleTodaySettimana = () => {
    if (!settimanaCorrente) return;
    const settimanaAggiornata = Settimane.find(s => s.value === settimanaCorrente.value) || settimanaCorrente;
    settimanaChanged(settimanaAggiornata);
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.value === (settimanaCorrente?.value || '')
        ? '#e6f2ff' : provided.backgroundColor,
      fontWeight: state.data.value === (settimanaCorrente?.value || '')
        ? 'bold' : 'normal',
      color: state.data.value === (settimanaCorrente?.value || '')
        ? '#000000'
        : provided.color
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10
    })
  };

  const sedeStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 10
    })
  };

  return (
    <Row className='filtri'>
      <Col xl={3} sm={4} xs={12} id="sede-filtro">
        <p className="inEvidenza">sede</p>
        <Select
          id="sede-filtro-select"
          name="sede"
          instanceId="sede"
          options={sediOptions}
          onChange={handleSedeChange}
          placeholder="Tutte le sedi"
          value={sede || { value: null, label: 'Tutte le sedi' }}
          styles={sedeStyles}
        />
      </Col>
      <Col xl={3} sm={4} xs={12} id="settimana-filtro">
        <p className="inEvidenza">settimana</p>
        <Select
          id="settimana-filtro-select"
          name="settimanainizio"
          instanceId="settimana"
          options={Settimane}
          onChange={settimanaChanged}
          placeholder="Seleziona..."
          value={settimanaLocale}
          styles={customStyles}
        />
      </Col>
      <Col xl={3} sm={4} xs={12} id="settimana-navigazione" className="d-flex align-items-end">
        <Button
          id="precedente"
          variant="primary"
          size="sm"
          onClick={handlePrevSettimana}
          disabled={!settimanaLocale || Settimane.findIndex(s => s.value === settimanaLocale?.value) === 0}
        >
          <FaChevronLeft></FaChevronLeft>
        </Button>
        <Button
          id="oggi"
          variant="outline-primary"
          size="sm" style={{
            fontWeight: 'bold'
          }}
          onClick={handleTodaySettimana}
          disabled={!settimanaCorrente || (settimanaLocale && settimanaLocale.value === settimanaCorrente.value)}
        >
          Oggi
        </Button>
        <Button
          id="successiva"
          variant="primary"
          size="sm"
          onClick={handleNextSettimana}
          disabled={!settimanaLocale || Settimane.findIndex(s => s.value === settimanaLocale?.value) === Settimane.length - 1}
        >
          <FaChevronRight></FaChevronRight>
        </Button>
      </Col>
    </Row>
    
  );
};

export default FiltroSintesiSettimana;
